@if (sourceLocations) {
  <p-pickList
    filterBy="country_name,state_name"
    breakpoint="1400px"
    scrollHeight="50rem"
    [source]="sourceLocations"
    [target]="targetLocations"
    sourceHeader="{{ 'Available' | translate }}"
    targetHeader="{{ 'Selected' | translate }}"
    [dragdrop]="true"
    [responsive]="true"
    [sourceStyle]="{ height: '50rem' }"
    [targetStyle]="{ height: '50rem' }"
    [showSourceControls]="false"
    [showTargetControls]="false"
    sourceFilterPlaceholder="{{ 'Search by name' | translate }}"
    targetFilterPlaceholder="{{ 'Search by name' | translate }}"
    (onMoveToSource)="locationChanged()"
    (onMoveToTarget)="locationChanged()"
    (onMoveAllToSource)="locationChanged()"
    (onMoveAllToTarget)="locationChanged()">
    <ng-template #item let-location>
      <div class="w-full border-b border-gray pb-2 !text-sm">
        <div class="flex justify-between">
          <div class="w-full leading-6 smallflag flex flex-row">
            {{ location.country_name }}

            @if (location.location_type === 'state') {
              <span class="text-teal-500 ml-1"> {{ location.state_name }}</span>
            }
          </div>

          @if (location?.province_count && location.province_count !== 0 && location.side === 0) {
            <div>
              <div
                class="text-sm text-primary"
                [id]="'button' + location.country_id"
                (click)="getStates(location.country_id); location.side = 1">
                {{ 'Filter' | translate }}: {{ 'State / Province' | translate }}
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>
  </p-pickList>
}

@if (!sourceLocations) {
  <offconon-skeleton-render-card />
}
